// extracted by mini-css-extract-plugin
var _1 = "EmailAttachedThreadsModal-moduleemptyState__jz8__";
var _2 = "EmailAttachedThreadsModal-moduletable__FwiJD TableComponent-moduleTable__mhqNq";
export { _1 as "emptyState", _2 as "table" }
